interface ToggleChipGroupProps {
  label: string;
  secondaryLabel?: string;
  items: Array<{ id: number; title?: string; name?: string }>;
  selectedIds: number[];
  onChange: (ids: number[]) => void;
}

export default function ToggleChipGroup({
  label,
  secondaryLabel,
  items,
  selectedIds,
  onChange,
}: ToggleChipGroupProps) {
  const toggle = (id: number) => {
    const newIds = selectedIds.includes(id)
      ? selectedIds.filter((i) => i !== id)
      : [...selectedIds, id];
    onChange(newIds);
  };

  return (
    <div className="mt-[14px]">
      <p className="text-[11px] font-bold uppercase tracking-[0.08em] text-pine-ink-soft mb-[8px]">
        {label}
        {secondaryLabel && (
          <span className="ml-1 font-normal normal-case tracking-normal">{secondaryLabel}</span>
        )}
      </p>
      <div className="flex flex-wrap gap-[6px]">
        {items.map((item) => {
          const isSelected = selectedIds.includes(item.id);
          const title = item.title ?? item.name ?? '';
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => toggle(item.id)}
              className={`px-3 py-1.5 rounded-full text-[12.5px] font-semibold border transition-colors ${
                isSelected
                  ? 'bg-pine-pine text-white border-pine-pine'
                  : 'bg-white text-pine-ink-soft border-pine-line hover:border-pine-pine'
              }`}
            >
              {title}
            </button>
          );
        })}
      </div>
    </div>
  );
}
